export const retry = (fn, options, retryCount = 0) => {
    return new Promise((resolve, reject) => {
        const { retries, interval } = Object.assign({ retries: 5, interval: 1 }, options);
        Promise.resolve(fn())
            .then((data) => resolve({ data, retryCount }))
            .catch((error) => {
            if (retryCount < retries) {
                setTimeout(() => {
                    retry(fn, {
                        retries,
                        interval
                    }, retryCount + 1).then(resolve, reject);
                }, interval);
            }
            else {
                reject(error);
            }
        });
    });
};
